import {MatrimonialProfile} from '../../api/response/matrimonial';
import {MatrimonialActionType} from './matrimonial.types';

export const matrimonialProfilesAction = (payload: MatrimonialProfile[]) => ({
  type: MatrimonialActionType.ProfileList,
  payload,
});
